import _parseInt from 'lodash/parseInt';
import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_PARKINGS_LIST,
  CPM_ADD_CARPARK_PARKING,
  CPM_UPDATE_CARPARK_PARKING,
  CPM_UPDATE_CARPARK_PARKING_STATE,
  CPM_DELETE_CARPARK_PARKING,
  CPM_GET_CARPARK_PARKING_ACCESSES_LIST,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeAccess } from '../../../models/cpm/access';
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
import { deserialize } from '../../../models/cpm/parking';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkParking;
// Ensure the slice always has an `accesses` object to avoid undefined access
const initialState = {
  ...initialSettings,
  accesses: (initialSettings && initialSettings.accesses) ? initialSettings.accesses : {},
};

const cpmCarparkParking = (state = initialState, action) => {
  let key;
  let mutationResult;
  let parkingId;
  // let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          delete: { ...initialSettings.delete },
          update: { ...initialSettings.update },
          // Keep accesses initialized
          accesses: state.accesses || {},
        };
      }
      if (action.target === 'listCarparkParkings') {
        return {
          ...state,
          accesses: { ...(initialSettings.accesses || {}) },
        };
      }
      switch (action.target) {
        case 'addCarparkParking':
          key = 'add';
          break;
        case 'updateCarparkParking':
          key = 'update';
          break;
        case 'deleteCarparkParking':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case CPM_GET_CARPARK_PARKINGS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_PARKINGS_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_PARKINGS_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listParkings.entries),
            pageNumber: _parseInt(action.data.listParkings.pageNumber),
            pageSize: _parseInt(action.data.listParkings.pageSize),
            totalEntries: _parseInt(action.data.listParkings.totalEntries),
            totalPages: _parseInt(action.data.listParkings.totalPages),
          },
        },
      };
    // ADD
    case CPM_ADD_CARPARK_PARKING:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_PARKING}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_PARKING}_SUCCESS`:
      mutationResult = action.data.addParking;
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
          type: action.parkingType,
        },
      };
    // UPDATE / UPDATE STATE
    case CPM_UPDATE_CARPARK_PARKING:
    case CPM_UPDATE_CARPARK_PARKING_STATE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_PARKING}_ERROR`:
    case `${CPM_UPDATE_CARPARK_PARKING_STATE}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_PARKING}_SUCCESS`:
      mutationResult = action.data.updateParking;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
          type: action.parkingType,
        },
      };
    case `${CPM_UPDATE_CARPARK_PARKING_STATE}_SUCCESS`:
      mutationResult = action.data.updateParkingState;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };
    // DELETE
    case CPM_DELETE_CARPARK_PARKING:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_PARKING}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_PARKING}_SUCCESS`:
      mutationResult = action.data.deleteParking;
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
          type: action.parkingType,
        },
      };
    // LIST ACCESSES
    case CPM_GET_CARPARK_PARKING_ACCESSES_LIST:
      parkingId = action.cbParams.parkingId;
      return {
        ...state,
        accesses: {
          ...state.accesses,
          [parkingId]: {
            loading: true,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_PARKING_ACCESSES_LIST}_SUCCESS`:
      parkingId = action.parkingId;
      return {
        ...state,
        accesses: {
          ...state.accesses,
          [parkingId]: {
            loading: false,
            data: deserializeAccess(action.data.listAccesses.entries),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkParking;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkParking.js